import { configureStore } from '@reduxjs/toolkit';

import { authApi } from '@/services/auth/api';
import { bannerApi } from '@/services/banner/api';
import { brandApi } from '@/services/brand/api';
import { categoryApi } from '@/services/category/api';
import { contractApi } from '@/services/contract/api';
import { customerServiceApi } from '@/services/customerService/api';
import { financeApi } from '@/services/finance/api';
import { marketingApi } from '@/services/marketing/api';
import { memberApi } from '@/services/member/api';
import { orderApi } from '@/services/order/api';
import { productApi } from '@/services/product/api';
import { productCategoryApi } from '@/services/productCategory/api';
import { shoppingCreditApi } from '@/services/shoppingCredit/api';
import { ticketApi } from '@/services/ticket/api';
import { env } from '@/utils/env';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [bannerApi.reducerPath]: bannerApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [contractApi.reducerPath]: contractApi.reducer,
    [customerServiceApi.reducerPath]: customerServiceApi.reducer,
    [financeApi.reducerPath]: financeApi.reducer,
    [marketingApi.reducerPath]: marketingApi.reducer,
    [memberApi.reducerPath]: memberApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [productCategoryApi.reducerPath]: productCategoryApi.reducer,
    [shoppingCreditApi.reducerPath]: shoppingCreditApi.reducer,
    [ticketApi.reducerPath]: ticketApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      bannerApi.middleware,
      brandApi.middleware,
      categoryApi.middleware,
      contractApi.middleware,
      customerServiceApi.middleware,
      financeApi.middleware,
      marketingApi.middleware,
      memberApi.middleware,
      orderApi.middleware,
      productApi.middleware,
      productCategoryApi.middleware,
      shoppingCreditApi.middleware,
      ticketApi.middleware
    ),
  devTools: !env.isProduction,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
